import { useEffect, useState, startTransition } from "react";
import { Link } from "react-router-dom";
import { pagePath } from "@/lib/translations";
import { api } from "@/lib/api";
import { Stars, RATING_TXT } from "@/components/RatingTile";

let cache = null;
/** Firmenbewertung (Ø + Anzahl) einmal je Sitzung laden – für das Vertrauens-Siegel im Footer. */
const useRatingSummary = () => {
  const [s, setS] = useState(cache);
  useEffect(() => { if (cache) return; api.get("/reviews/summary").then((r) => { cache = r.data; startTransition(() => setS(r.data)); }).catch(() => {}); }, []);
  return s;
};

/** Vertrauens-Siegel: Sterne + „4,8 von 5 · aus 796 Bewertungen“, verlinkt auf die Bewertungsseite. `inline`: alles in einer Zeile (Hero), sonst zweizeilig kompakt (Footer-Spalte). Bewusst kein schema.org (Eigenbewertung). */
export const RatingBadge = ({ lang = "de", testId = "footer-rating-badge", className = "", inline = false }) => {
  const s = useRatingSummary();
  if (!s || !(s.count > 0)) return null;
  const x = RATING_TXT[lang] || RATING_TXT.en;
  const avg = lang === "en" ? String(s.average) : String(s.average).replace(".", ",");
  return (
    <Link to={pagePath("bewertungen")} title={x.link} data-testid={testId}
          className={`inline-flex items-center gap-3 rounded-xl border border-white/20 bg-black/20 backdrop-blur-sm px-3 py-2 hover:bg-black/25 transition-colors ${className}`}>
      <Stars value={s.average} className="w-3.5 h-3.5" />
      {inline ? (
        <span className="text-sm leading-tight whitespace-nowrap"><span className="font-semibold" data-testid={`${testId}-avg`}>{avg}</span> {x.of} <span className="opacity-80" data-testid={`${testId}-count`}>· {x.from(s.count)}</span></span>
      ) : (
        <span className="text-sm leading-tight whitespace-nowrap">
          <span className="font-semibold" data-testid={`${testId}-avg`}>{avg}</span> {x.of}
          <span className="block text-[11px] opacity-90" data-testid={`${testId}-count`}>{x.from(s.count)}</span>
        </span>
      )}
    </Link>
  );
};
